<template>
  <div class="grid-container full"
       :class="{grey: side === 'right'}">
    <div v-if="side === 'right'" class="grid-x page-contents-6" >
      <div class="small-12 medium-6 cell left-column">
        <h2>{{title}}</h2>
        <p v-html="content">
        </p>
      </div>
      <div class=" small-12 medium-6 cell right-column">
        <a :tabindex="tabIndex" :href="url" target="_blank">
        <img
          class='research-image'
          :src='image' />
        </a>
      </div>
    </div>
    <div v-else class="grid-x page-contents-8" >
      <div class="small-12 medium-6 cell left-column  hide-for-small-only">
        <a :tabindex="tabIndex" :href="url" target="_blank">
          <img
            class='research-image research-image-left'
            :src='image' />
        </a>
      </div>
      <div class="small-12 medium-6 cell right-column-left">
        <h2>{{title}}</h2>
        <p v-html="content">
        </p>
      </div>
      <div class="small-12 medium-6 cell right-column hide-for-medium">
        <a :href="url" target="_blank">
          <img
            class='research-image'
            :src='image' />
        </a>
      </div>
    </div>

  </div>
</template>

<script>


export default {
  name: 'RareBestAdvice',
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    side: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    tabIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .grey {
    background-color: #efefef;
  }

  @media only screen and (max-width: 800px) {
    .full {
      height: auto;
    }

    a {
      display: flex;
      justify-content: center;
      height: 241px;
    }

    .research-image {
      width: 320px;
      height: auto;
      margin: 15px 0 40px 0;
      object-fit: contain;
    }

  h2 {
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: normal;
    margin: 38px 0 20px 0;
    color: $main-text;
  }

  p {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: center;
    color: $main-text;
    padding-left: 10px;
    padding-right: 10px;
  }
  }

  @media only screen and (min-width: 641px) {

    .full {
      height: 600px;
    }

    .right-column {
      padding-left: 105px;
    }

    .right-column-left {
      padding-left: 45px;
    }

    h2 {
      font-size: 56px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      color: $main-text;
      margin-top: 95px;
    }

    p {
      font-size: 21px;
      font-weight: normal;
      font-style: normal;
      line-height: 1.52;
      letter-spacing: normal;
      color: $main-text;
    }

    a {
      display: flex;
      justify-content: center;
    }

    .research-image {
      margin-top: 50px;
      max-width: none;
      height: 500px;
    }
    .research-image-left {
      margin-right: 100px;
    }
  }

</style>




// WEBPACK FOOTER //
// src/pages/research/components/RareResearchBox.vue